import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { loginAction } from "../../redux/actions/userAction";
// import axios from "axios";
import toast, { Toaster } from "react-hot-toast";


const Login = () => {
  const [emailaddress, setEmailAddress] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch()
  const { error, loading, message} = useSelector(state=> state.user)

  useEffect(()=> {
    if(error){
      toast.error(error)
      dispatch({
        type : 'clearError'
      })
    }

    if(message){
      toast.success(message)
      dispatch({
        type : 'clearMessage'
      })
    }

  }, [dispatch, error, message])
  const loginHandler = (e) => { 
    e.preventDefault()
    // const data = {
    //   "email": emailaddress,
    //   "password" : password
    // }
    // console.log(data)
    // const callingAPI = async() => {
    //   const temp = await axios.post('http://localhost:4000/v1/api/user/login' , data)
    //   console.log(temp)
    // }
    // callingAPI()
   
    dispatch(loginAction(emailaddress, password))

  }
  return (
    <>
    <Toaster/>
      <div className="bg-brand_nero flex flex-col justify-center items-center h-[800px] py-24 my-auto text-white  w-full">
        <div className="bg-brand_jaguar h-[400px] px-12 lg:px-24 flex flex-col justify-center items-center lg:w-[600px]">
          <h1 className="text-xl my-3">Welcome Back!</h1>

          <form onSubmit={(e)=> {
              loginHandler(e)
            }}  action="" className="flex-col flex px-4 my-6 lg:w-[400px] ">
            <input
              className="my-3 py-1 px-6 text-black border-none outline-brand_yellow"
              type="text"
              value={emailaddress}
              placeholder="you@example.com"
              onChange={(e) => {
                setEmailAddress(e.target.value);
              }}
            />

            <input
              className="my-3 py-1 px-6 text-black border-none outline-brand_yellow"
              type="password"
              value={password}
              placeholder="Atleast 8 characters"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />

            <Link className="text-right my-1" to='/forgetpassword'><span className="hover:underline text-brand_yellow">Forgot password?</span></Link>

            <button disabled={loading} className={` ${loading ? 'bg-yellow-100 text-gray-600' : 'bg-brand_yellow text-black'} transition hover:-translate-y-1 ease-linear my-3  px-6 py-1 font-outfit font-semibold`}>
              Login
            </button>

            
          </form>
          <h1>Don't have an account? <Link to='/signup'><span className="hover:underline text-brand_yellow">Sign Up</span></Link></h1>
        </div>
      </div>
    </>
  );
};

export default Login;
